module.exports = __webpack_public_path__ + "assets/ad34fb859f53c9ba29b5330e275f4d15.png";